import { render, staticRenderFns } from "./dicas.vue?vue&type=template&id=e6b619d6&scoped=true&"
import script from "./dicas.vue?vue&type=script&lang=js&"
export * from "./dicas.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap.min.css?vue&type=style&index=0&id=e6b619d6&scoped=true&lang=css&"
import style1 from "./dicas.vue?vue&type=style&index=1&id=e6b619d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b619d6",
  null
  
)

export default component.exports